import type { ComponentType } from "react";

import type {
  CustomVizPublishedValue,
  DashboardUpdatedValue,
} from "metabase/api/ai-streaming/schemas";
import { definePluginSlot } from "metabase/plugins";
import type { Dispatch, GetState } from "metabase/redux/store";

import type { SlashCommand } from "./state/types";

export type MetabotSlashCommandHandler = (args: {
  command: SlashCommand;
  conversationId: string;
  dispatch: Dispatch;
  getState: GetState;
}) => boolean;

type MetabotSlashCommandsPlugin = {
  handleSlashCommand: MetabotSlashCommandHandler;
};

export const PLUGIN_METABOT_SLASH_COMMANDS = definePluginSlot(
  (): MetabotSlashCommandsPlugin => ({
    handleSlashCommand: () => false,
  }),
);

export type MetabotDashboardUpdatedHandler = (args: {
  value: DashboardUpdatedValue;
  isFullPageMetabot: boolean;
  dispatch: Dispatch;
  getState: GetState;
}) => void;

export type MetabotDashboardUpdatedMessageProps = {
  value: DashboardUpdatedValue;
  readonly: boolean;
};

type MetabotDashboardsPlugin = {
  handleDashboardUpdated: MetabotDashboardUpdatedHandler;
  DashboardUpdatedMessage: ComponentType<MetabotDashboardUpdatedMessageProps> | null;
};

/** Metabot building and changing dashboards: what happens when it saves one, and its card in the chat. */
export const PLUGIN_METABOT_DASHBOARDS = definePluginSlot(
  (): MetabotDashboardsPlugin => ({
    handleDashboardUpdated: () => {},
    DashboardUpdatedMessage: null,
  }),
);

export type MetabotCustomVizPublishedMessageProps = {
  value: CustomVizPublishedValue;
  readonly: boolean;
};

type MetabotCustomVizPlugin = {
  CustomVizPublishedMessage: ComponentType<MetabotCustomVizPublishedMessageProps> | null;
};

/** Metabot building custom visualizations: its card in the chat for one it published. */
export const PLUGIN_METABOT_CUSTOM_VIZ = definePluginSlot(
  (): MetabotCustomVizPlugin => ({
    CustomVizPublishedMessage: null,
  }),
);
